import NavigationService from '../../../ts/service/navigation-service.ts';

angular
  .module('jrSerpService', [])
  .value('NavigationService', NavigationService)
  .factory('SearchUrlService', SearchUrlService)
  .factory('FiltersUrlService', FiltersUrlService);

FiltersUrlService.$inject = ['SearchUrlService', '$window', 'NavigationService'];

function SearchUrlService() {
  function getURLParameter(name) {
    return (
      decodeURIComponent(
        (new RegExp(`[?|&]${name}=([^&;]+?)(&|#|;|$)`).exec(location.search) || [
          '',
          '',
        ])[1].replace(/\+/g, '%20')
      ) || null
    );
  }

  return {
    getURLParameter,
  };
}

function FiltersUrlService(SearchUrlService, $window, NavigationService) {
  function getFilterUrl(filterType, filterValue) {
    const filter = new RegExp(`${filterType}=[^&]+`);

    const url =
      filterType === 'shm'
        ? NavigationService.removeQueryStringParameter('p', $window.location.href)
        : $window.location.href;

    return SearchUrlService.getURLParameter(filterType)
      ? url.replace(filter, `${filterType}=${filterValue}`)
      : `${url + (url.indexOf('?') > -1 ? '&' : '?') + filterType}=${filterValue}`;
  }

  return {
    getFilterUrl,
  };
}
